export default str => str.split(/[:\s+]/);
